import React from "react";
import type { tBusinessTask, tTaskClaim } from "@/types";
import { TFunction } from "i18next";
import { useQuery } from "react-query";
import { TaskClaimsCacheService } from "@/services/taskClaims/cache";
import { TasksAPI } from "@/api/tasks";
import Info from "_c/atoms/Info";

type tProps = {
  task: tBusinessTask;
  t: TFunction;
};
const ClaimDetails = ({ task }: tProps) => {
  const { data: claim } = useQuery(
    TaskClaimsCacheService.buildSingleTaskClaimQueryKey(task.claim!),
    () => TasksAPI.getDisputeById(task.claim!) as Promise<tTaskClaim>,
    {
      refetchInterval: false,
    }
  );
  if (!claim?.verdict) return null;
  return (
    <div>
      <Info
        css={`
          margin-top: 0;
          display: inline-block;
        `}
        isError
      >
        {claim.verdict}
      </Info>
    </div>
  );
};

export default ClaimDetails;
